import React, { Component } from 'react';
import { Badge } from 'reactstrap';

class SamplePackTagsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tagValue: ''
        };
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.onAddTag(this.state.tagValue);
            this.setState({tagValue: ''});
        }
    }

    onInputChanged(val) {
        this.setState({tagValue: val});
    }

    render() {
        return (
            <div>
              <input                  
                onKeyUp={(e) => this.onKeyPress(e)}
                onChange={e => this.onInputChanged(e.target.value)}
                value={this.state.tagValue}
                placeholder="Type sample pack tags here"
                className='tags-input sample-pack-input'
                type="text"/>
                <div>
                  {this.props.tags.length > 0 ?
                  <span className="tags-label">TAGS:</span> : '' }
                  {this.props.tags.map(
                      (tag) =>
                          <Badge
                                color="light">{tag}
                          </Badge>)}
                  {this.props.tags.length > 0 ?
                    <span onClick={() => this.props.onClearClicked()} className="clear-tags-button">
                      CLEAR
                    </span> : ''}
              </div>
            </div>
        );
    }
}
                
export default SamplePackTagsComponent;
